var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Heading, AlertDialog, AlertDialogOverlay, AlertDialogContent, AlertDialogHeader, AlertDialogBody, AlertDialogFooter, AlertDialogCloseButton, Spacer, Flex, } from 'shared/components';
import { Close } from 'shared/assets/icons';
import { useAppointmentFromContext } from 'pages/Appointment';
import { useUndoTimerContext } from '../contexts';
import { UndoReason } from './undoReason';
import { FormProvider, useForm } from 'react-hook-form';
import { useHref } from 'react-router-dom';
import { UndoTimer } from './undoTimer';
import { ReasonWarning } from './reasonWarning';
import { UndoActions } from './undoActions';
import { noteSchema } from 'constants/note-schemas';
import { useSubmitUndo } from '../hooks';
import { linkToAppointment } from 'shared/utils';
import { useNoteSchemaContext } from '../../note';
export var UndoCtaModal = function (_a) {
    var _b;
    var disclosure = _a.disclosure, note = _a.note;
    var cancelRef = useRef(null);
    var canUndo = useUndoTimerContext().canUndo;
    var schemaForm = useNoteSchemaContext().form;
    var form = useForm();
    var appointment = useAppointmentFromContext();
    var appointmentHref = useHref(linkToAppointment(appointment.id));
    var _c = useSubmitUndo((_b = note === null || note === void 0 ? void 0 : note.id) !== null && _b !== void 0 ? _b : '', function () {
        schemaForm.reset();
        disclosure.onClose();
        // hard refresh to completely reset form state
        window.location.href = appointmentHref;
    }, disclosure.onClose), submit = _c.submit, isLoading = _c.isLoading;
    var canChangeToDraft = (note === null || note === void 0 ? void 0 : note.noteSchema) === noteSchema.notAttended || (note === null || note === void 0 ? void 0 : note.noteSchema) === noteSchema.lateCancel;
    useEffect(function () {
        if (!canUndo) {
            disclosure.onClose();
        }
    }, [canUndo]);
    useEffect(function () {
        if (disclosure.isOpen) {
            form.reset();
        }
    }, [disclosure.isOpen]);
    return (_jsx(FormProvider, __assign({}, form, { children: _jsx(AlertDialog, __assign({ size: "2xl", isOpen: disclosure.isOpen, leastDestructiveRef: cancelRef || null, onClose: disclosure.onClose }, { children: _jsx(AlertDialogOverlay, { children: _jsx(AlertDialogContent, { children: _jsxs("form", __assign({ onSubmit: form.handleSubmit(submit) }, { children: [_jsx(AlertDialogHeader, __assign({ px: 5 }, { children: _jsxs(Flex, __assign({ align: "center" }, { children: [_jsx(Heading, __assign({ "data-testid": "undoNotesheader", size: "h2" }, { children: "Undo signed note?" })), _jsx(Spacer, {}), _jsx(AlertDialogCloseButton, __assign({ color: "green.500", boxSize: 4, position: "inherit", ref: cancelRef }, { children: _jsx(Close, {}) }))] })) })), _jsxs(AlertDialogBody, __assign({ px: 5 }, { children: [_jsx(UndoTimer, {}), _jsx(UndoReason, { canChangeToDraft: canChangeToDraft }), _jsx(ReasonWarning, {})] })), _jsx(AlertDialogFooter, __assign({ paddingInline: 5 }, { children: _jsx(UndoActions, { disclosure: disclosure, isLoading: isLoading }) }))] })) }) }) })) })));
};
